/**
 * Its own module rather than sitting beside `VolgordeKnoppen`: a file exporting both a component
 * and a plain function loses fast refresh, and this is the half three screens import.
 */
export function verplaats<T>(rijen: readonly T[], index: number, delta: number): T[] {
  const doel = index + delta;
  if (doel < 0 || doel >= rijen.length) return [...rijen];

  const volgende = [...rijen];
  [volgende[index], volgende[doel]] = [volgende[doel], volgende[index]];
  return volgende;
}
